// Static image imports (.webp) — use with <Image src={X} /> or as X.src for background-image

// imports

import Bg from "./bg.webp";
import Avatar1 from "./avatar1.webp";
import Avatar2 from "./avatar2.webp";
import Avatar3 from "./avatar3.webp";
import Avatar4 from "./avatar4.webp";
import Avatar5 from "./avatar5.webp";
import Avatar6 from "./avatar6.webp";

import CTAImage from "./CTAImage.webp";
import CyberVector from './Vector.webp';
import ApplyCyberLogo from './ApplyCyber.webp';
import HowWork from './HowWork.webp';
import Flagship from './Flagship.webp';
import Artitecture from './Artitecture.png';
import ValuePro from './ValuePro.png';
import MainCase from './mainCase.webp';
import TMA_AI from './TMA_AI.webp';
import AI_Powered from './AI_Powered.webp';
import Ball from './ball.webp';
import MainAbout from './MainAbout.webp';
import OurMission from './OurMission.webp';
import TurningVision from './TurningVision.webp';
import ContactUs from './contact-us.webp';
import trustLogo from './trustLogo.png';


// exports
export {
    Avatar1,
    Avatar2,
    Avatar3,
    Avatar4,
    Avatar5,
    Avatar6,
    Bg,
    CTAImage,
    CyberVector,
    ApplyCyberLogo,
    HowWork,
    Flagship,
    Artitecture,
    ValuePro,
    MainCase,
    TMA_AI,
    AI_Powered,
    Ball,
    MainAbout, TurningVision, OurMission,
    ContactUs,
    trustLogo
}